import React from 'react';
import { CompanyRegistration, CompanyRegistrationErrors } from '../../../types';
import { activityTypes, howDidYouKnow } from '../../../utils/data';

interface CommercialInfoSectionProps {
  formData: Partial<CompanyRegistration>;
  errors: CompanyRegistrationErrors;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const CommercialInfoSection: React.FC<CommercialInfoSectionProps> = ({
  formData,
  errors,
  onInputChange
}) => {
  return (
    <>
      <h3 className="uk-heading-small uk-margin-small-top">Información Comercial</h3>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="tipo-actividad">Tipo de Actividad *</label>
        <div className="uk-form-controls">
          <select 
            className={`uk-select ${errors.tipoActividad ? 'uk-form-danger' : ''}`}
            id="tipo-actividad" 
            name="tipoActividad"
            value={formData.tipoActividad || ''}
            onChange={onInputChange}
            required
            style={{ color: '#333', backgroundColor: '#fff', textTransform: 'none' }}
          >
            <option value="">Seleccionar...</option>
            {activityTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
          {errors.tipoActividad && (
            <div className="uk-text-danger uk-text-small">{errors.tipoActividad}</div>
          )}
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="descripcion">Descripción *</label>
        <div className="uk-form-controls">
          <textarea 
            className={`uk-textarea ${errors.descripcion ? 'uk-form-danger' : ''}`}
            id="descripcion" 
            name="descripcion"
            rows={3} 
            placeholder="Describe las actividades principales de tu empresa" 
            value={formData.descripcion || ''}
            onChange={onInputChange}
            required
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
          {errors.descripcion && (
            <div className="uk-text-danger uk-text-small">{errors.descripcion}</div>
          )}
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="rubros">Rubros *</label>
        <div className="uk-form-controls">
          <textarea 
            className={`uk-textarea ${errors.rubros ? 'uk-form-danger' : ''}`}
            id="rubros" 
            name="rubros"
            rows={2} 
            placeholder="Lista los rubros principales de tu empresa" 
            value={formData.rubros || ''}
            onChange={onInputChange}
            required
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
          {errors.rubros && (
            <div className="uk-text-danger uk-text-small">{errors.rubros}</div>
          )}
        </div>
      </div>
      
      <div className="uk-margin-small">
        <label className="uk-form-label" htmlFor="marcas">Marcas</label>
        <div className="uk-form-controls">
          <input 
            className="uk-input"
            id="marcas" 
            name="marcas"
            type="text" 
            placeholder="Marcas que comercializa o representa"
            value={formData.marcas || ''}
            onChange={onInputChange}
            style={{ color: '#333', backgroundColor: '#fff' }}
          />
        </div>
      </div>
      
      <div className="uk-grid uk-grid-small" data-uk-grid>
        <div className="uk-width-1-2@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="como-nos-conocio">¿Cómo nos conoció? *</label>
            <div className="uk-form-controls">
              <select 
                className={`uk-select ${errors.comoNosConocio ? 'uk-form-danger' : ''}`}
                id="como-nos-conocio" 
                name="comoNosConocio"
                value={formData.comoNosConocio || ''}
                onChange={onInputChange}
                required
                style={{ color: '#333', backgroundColor: '#fff', textTransform: 'none' }}
              >
                <option value="">Seleccionar...</option>
                {howDidYouKnow.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
              {errors.comoNosConocio && (
                <div className="uk-text-danger uk-text-small">{errors.comoNosConocio}</div>
              )}
            </div>
          </div>
        </div>
        
        <div className="uk-width-1-2@m">
          <div className="uk-margin-small">
            <label className="uk-form-label" htmlFor="contacto">Contacto *</label>
            <div className="uk-form-controls">
              <input 
                className={`uk-input ${errors.contacto ? 'uk-form-danger' : ''}`}
                id="contacto" 
                name="contacto"
                type="text" 
                placeholder="Nombre de la persona de contacto" 
                value={formData.contacto || ''}
                onChange={onInputChange}
                required 
                style={{ color: '#333', backgroundColor: '#fff' }}
              />
              {errors.contacto && (
                <div className="uk-text-danger uk-text-small">{errors.contacto}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommercialInfoSection;
